
export const withRetry = async <T>(fn: () => Promise<T>, maxRetries = 3, delay = 500): Promise<T> => {
  for (let attempt = 0; attempt < maxRetries; attempt++) {
    try {
      return await fn();
    } catch (error) {
      if (attempt === maxRetries - 1) throw error;
      await new Promise((res) => setTimeout(res, delay));
    }
  }
  throw new Error("Unreachable");
};